import { SortingCriteria, VehicleListing } from '@cinch-nx/data-search'
import { ReactNode, useEffect, useState } from 'react'
import { fetchSearchVehicles } from '@retail-common/data-search-vehicles-api'
import { SearchParams } from '@retail-common/util-search-param-types'
import CarouselSection from './carousel-section/carousel-section'
import { Env, readFromEnv } from '@cinch-nx/environments'

export interface CarsCarouselProps {
  title?: string
  sortBy?: SortingCriteria
  showOnlyCinchStock?: boolean
  priceFrom?: number
  priceTo?: number
  carsCondition?: 'new' | 'used'
  disclaimer?: string
  showBrowseAllCarsCard?: boolean
  financeRepresentativeExample?: ReactNode
}

export function CarsCarousel({
  title,
  sortBy,
  priceFrom,
  priceTo,
  carsCondition,
  disclaimer,
  showBrowseAllCarsCard = false,
  financeRepresentativeExample,
}: CarsCarouselProps) {
  const [vehicles, setVehicles] = useState<VehicleListing[]>()
  useEffect(() => {
    const fetchVehicleData = async (params: Partial<SearchParams>) => {
      const data = await fetchSearchVehicles(
        readFromEnv(Env.SearchServiceUrl),
        params,
      )
      setVehicles(data.response.vehicleListings)
    }

    fetchVehicleData({
      ...(priceFrom && { fromPrice: [String(priceFrom)] }),
      ...(priceTo && { toPrice: [String(priceTo)] }),
      ...(sortBy && { sortingCriteria: sortBy }),
      ...(carsCondition && { condition: [carsCondition] }),
    })
  }, [])
  return (
    <CarouselSection
      title={title}
      disclaimer={disclaimer}
      vehicles={vehicles}
      showBrowseAllCarsCard={showBrowseAllCarsCard}
      showMonthlyPrices={carsCondition === 'new'}
      financeRepresentativeExample={financeRepresentativeExample}
    />
  )
}

export default CarsCarousel
